export default __webpack_public_path__ + "static/media/1Place-Childcare-logo-tagline.548ce2d6.png";